import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from './alert.service';
import { Alert, AlertType } from './alert.model';
import { LabelService } from '../../services/label.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit, OnDestroy {

  alerts: Alert[] = [];
  subscription: Subscription | undefined;
  AlertType: typeof AlertType = AlertType;

  readonly disappearTimePrimary = 5000;
  readonly disappearTimeDefault = 30000;

  constructor(private alertService: AlertService, public labelService: LabelService) {
  }

  ngOnInit(): void {
    this.subscription = this.alertService.onNext().subscribe(alert => {
      this.alerts.push(alert);

      const disappearTime = alert.type === AlertType.Primary ? this.disappearTimePrimary : this.disappearTimeDefault;

      // auto close alert
        setTimeout(() => {
          this.close(alert);
        }, disappearTime);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  close(alert: Alert): void {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
}


